{
  "regions": {
    "EMEA": {
      "countries": [
        {"name": "Albania", "id": "ALB"},
        {"name": "Andorra", "id": "AND"},
        {"name": "Austria", "id": "AUT"},
        {"name": "Belarus", "id": "BLR"},
        {"name": "Belgium", "id": "BEL"},
        {"name": "Bosnia and Herzegovina", "id": "BIH"},
        {"name": "Bulgaria", "id": "BGR"},
        {"name": "Croatia", "id": "HRV"},
        {"name": "Cyprus", "id": "CYP"},
        {"name": "Czech Republic", "id": "CZE"},
        {"name": "Denmark", "id": "DNK"},
        {"name": "Estonia", "id": "EST"},
        {"name": "Finland", "id": "FIN"},
        {"name": "France", "id": "FRA"},
        {"name": "Germany", "id": "DEU"},
        {"name": "Greece", "id": "GRC"},
        {"name": "Hungary", "id": "HUN"},
        {"name": "Iceland", "id": "ISL"},
        {"name": "Ireland", "id": "IRL"},
        {"name": "Italy", "id": "ITA"},
        {"name": "Latvia", "id": "LVA"},
        {"name": "Liechtenstein", "id": "LIE"},
        {"name": "Lithuania", "id": "LTU"},
        {"name": "Luxembourg", "id": "LUX"},
        {"name": "Malta", "id": "MLT"},
        {"name": "Moldova", "id": "MDA"},
        {"name": "Monaco", "id": "MCO"},
        {"name": "Montenegro", "id": "MNE"},
        {"name": "Netherlands", "id": "NLD"},
        {"name": "North Macedonia", "id": "MKD"},
        {"name": "Norway", "id": "NOR"},
        {"name": "Poland", "id": "POL"},
        {"name": "Portugal", "id": "PRT"},
        {"name": "Romania", "id": "ROU"},
        {"name": "Russia", "id": "RUS"},
        {"name": "San Marino", "id": "SMR"},
        {"name": "Serbia", "id": "SRB"},
        {"name": "Slovakia", "id": "SVK"},
        {"name": "Slovenia", "id": "SVN"},
        {"name": "Spain", "id": "ESP"},
        {"name": "Sweden", "id": "SWE"},
        {"name": "Switzerland", "id": "CHE"},
        {"name": "Ukraine", "id": "UKR"},
        {"name": "United Kingdom", "id": "GBR"},
        {"name": "Vatican City", "id": "VAT"},
        {"name": "Bahrain", "id": "BHR"},
        {"name": "Iran", "id": "IRN"},
        {"name": "Iraq", "id": "IRQ"},
        {"name": "Israel", "id": "ISR"},
        {"name": "Jordan", "id": "JOR"},
        {"name": "Kuwait", "id": "KWT"},
        {"name": "Lebanon", "id": "LBN"},
        {"name": "Oman", "id": "OMN"},
        {"name": "Palestine", "id": "PSE"},
        {"name": "Qatar", "id": "QAT"},
        {"name": "Saudi Arabia", "id": "SAU"},
        {"name": "Syria", "id": "SYR"},
        {"name": "Turkey", "id": "TUR"},
        {"name": "United Arab Emirates", "id": "ARE"},
        {"name": "Yemen", "id": "YEM"},
        {"name": "Algeria", "id": "DZA"},
        {"name": "Angola", "id": "AGO"},
        {"name": "Benin", "id": "BEN"},
        {"name": "Botswana", "id": "BWA"},
        {"name": "Burkina Faso", "id": "BFA"},
        {"name": "Burundi", "id": "BDI"},
        {"name": "Cabo Verde", "id": "CPV"},
        {"name": "Cameroon", "id": "CMR"},
        {"name": "Central African Republic", "id": "CAF"},
        {"name": "Chad", "id": "TCD"},
        {"name": "Comoros", "id": "COM"},
        {"name": "Congo (Democratic Republic of)", "id": "COD"},
        {"name": "Congo (Republic of)", "id": "COG"},
        {"name": "Côte d'Ivoire", "id": "CIV"},
        {"name": "Djibouti", "id": "DJI"},
        {"name": "Egypt", "id": "EGY"},
        {"name": "Equatorial Guinea", "id": "GNQ"},
        {"name": "Eritrea", "id": "ERI"},
        {"name": "Eswatini", "id": "SWZ"},
        {"name": "Ethiopia", "id": "ETH"},
        {"name": "Gabon", "id": "GAB"},
        {"name": "Gambia", "id": "GMB"},
        {"name": "Ghana", "id": "GHA"},
        {"name": "Guinea", "id": "GIN"},
        {"name": "Guinea-Bissau", "id": "GNB"},
        {"name": "Kenya", "id": "KEN"},
        {"name": "Lesotho", "id": "LSO"},
        {"name": "Liberia", "id": "LBR"},
        {"name": "Libya", "id": "LBY"},
        {"name": "Madagascar", "id": "MDG"},
        {"name": "Malawi", "id": "MWI"},
        {"name": "Mali", "id": "MLI"},
        {"name": "Mauritania", "id": "MRT"},
        {"name": "Mauritius", "id": "MUS"},
        {"name": "Morocco", "id": "MAR"},
        {"name": "Mozambique", "id": "MOZ"},
        {"name": "Namibia", "id": "NAM"},
        {"name": "Niger", "id": "NER"},
        {"name": "Nigeria", "id": "NGA"},
        {"name": "Rwanda", "id": "RWA"},
        {"name": "São Tomé and Príncipe", "id": "STP"},
        {"name": "Senegal", "id": "SEN"},
        {"name": "Seychelles", "id": "SYC"},
        {"name": "Sierra Leone", "id": "SLE"},
        {"name": "Somalia", "id": "SOM"},
        {"name": "Somaliland", "id": "-99"},
        {"name": "South Africa", "id": "ZAF"},
        {"name": "South Sudan", "id": "SSD"},
        {"name": "Sudan", "id": "SDN"},
        {"name": "Tanzania", "id": "TZA"},
        {"name": "Togo", "id": "TGO"},
        {"name": "Tunisia", "id": "TUN"},
        {"name": "Uganda", "id": "UGA"},
        {"name": "Zambia", "id": "ZMB"},
        {"name": "Zimbabwe", "id": "ZWE"},
        {"name": "Afghanistan", "id": "AFG"},
        {"name": "Armenia", "id": "ARM"},
        {"name": "Azerbaijan", "id": "AZE"},
        {"name": "Georgia", "id": "GEO"},
        {"name": "Kazakhstan", "id": "KAZ"},
        {"name": "Kosovo", "id": "CS-KM"},
        {"name": "Kyrgyzstan", "id": "KGZ"},
        {"name": "Tajikistan", "id": "TJK"},
        {"name": "Turkmenistan", "id": "TKM"},
        {"name": "Uzbekistan", "id": "UZB"},
        {"name": "Western Sahara", "id": "ESH"},
        {"name": "Greenland", "id": "GRL"}
      ]
    },
    "LatAm": {
      "countries": [
        {"name": "Argentina", "id": "ARG"},
        {"name": "Bolivia", "id": "BOL"},
        {"name": "Brazil", "id": "BRA"},
        {"name": "Chile", "id": "CHL"},
        {"name": "Colombia", "id": "COL"},
        {"name": "Costa Rica", "id": "CRI"},
        {"name": "Cuba", "id": "CUB"},
        {"name": "Dominican Republic", "id": "DOM"},
        {"name": "Ecuador", "id": "ECU"},
        {"name": "El Salvador", "id": "SLV"},
        {"name": "Guatemala", "id": "GTM"},
        {"name": "Haiti", "id": "HTI"},
        {"name": "Honduras", "id": "HND"},
        {"name": "Jamaica", "id": "JAM"},
        {"name": "Mexico", "id": "MEX"},
        {"name": "Nicaragua", "id": "NIC"},
        {"name": "Panama", "id": "PAN"},
        {"name": "Paraguay", "id": "PRY"},
        {"name": "Peru", "id": "PER"},
        {"name": "Puerto Rico", "id": "PRI"},
        {"name": "Trinidad and Tobago", "id": "TTO"},
        {"name": "Uruguay", "id": "URY"},
        {"name": "Venezuela", "id": "VEN"},
        {"name": "Belize", "id": "BLZ"},
        {"name": "French Guiana", "id": "GUF"},
        {"name": "Guyana", "id": "GUY"},
        {"name": "Suriname", "id": "SUR"},
        {"name": "The Bahamas", "id": "BHS"}
      ]
    },
    "US": {
      "countries": [
        {"name": "United States", "id": "USA"}
      ]
    },
    "Canada": {
      "countries": [
        {"name": "Canada", "id": "CAN"}
      ]
    },
    "APAC": {
      "countries": [
        {"name": "Australia", "id": "AUS"},
        {"name": "Bangladesh", "id": "BGD"},
        {"name": "Bhutan", "id": "BTN"},
        {"name": "Brunei", "id": "BRN"},
        {"name": "Cambodia", "id": "KHM"},
        {"name": "China", "id": "CHN"},
        {"name": "Fiji", "id": "FJI"},
        {"name": "Hong Kong", "id": "HKG"},
        {"name": "India", "id": "IND"},
        {"name": "Indonesia", "id": "IDN"},
        {"name": "Japan", "id": "JPN"},
        {"name": "Laos", "id": "LAO"},
        {"name": "Macau", "id": "MAC"},
        {"name": "Malaysia", "id": "MYS"},
        {"name": "Maldives", "id": "MDV"},
        {"name": "Mongolia", "id": "MNG"},
        {"name": "Myanmar", "id": "MMR"},
        {"name": "Nepal", "id": "NPL"},
        {"name": "New Zealand", "id": "NZL"},
        {"name": "North Korea", "id": "PRK"},
        {"name": "Pakistan", "id": "PAK"},
        {"name": "Papua New Guinea", "id": "PNG"},
        {"name": "Philippines", "id": "PHL"},
        {"name": "Singapore", "id": "SGP"},
        {"name": "South Korea", "id": "KOR"},
        {"name": "Sri Lanka", "id": "LKA"},
        {"name": "Taiwan", "id": "TWN"},
        {"name": "Thailand", "id": "THA"},
        {"name": "Timor-Leste", "id": "TLS"},
        {"name": "Vietnam", "id": "VNM"},
        {"name": "East Timor", "id": "TLS"},
        {"name": "New Caledonia", "id": "NCL"},
        {"name": "Solomon Islands", "id": "SLB"},
        {"name": "Vanuatu", "id": "VUT"}
      ]
    }
  }
}